import BasicRouterView from "../../components/BasicRouterView.vue";

const centroDeCustoRoutes = {
  path: "cdc",
  redirect: { name: "centrodecusto-listar" },
  meta: {
    label: "Centro de Custo",
    icon: "home",
    show: true,
    favorite: false,
  },
  component: BasicRouterView,
  children: [
    {
      path: "centro-de-custo/listar",
      name: "centrodecusto-listar",
      meta: {
        label: "Listar",
        icon: "list",
        show: true,
      },
      component: () =>
        import(
          /* webpackChunkName: "centrodecusto" */ "./views/ListarCentroDeCusto.vue"
        ),
    },
    {
      path: "centro-de-custo/detalhe/:centroCustoId",
      name: "centrodecusto-detalhe",
      meta: {
        label: "Listar",
        icon: "list",
        show: false,
      },
      component: () =>
        import(
          /* webpackChunkName: "centrodecusto" */ "./views/DetalharCentroDeCusto.vue"
        ),
    },
    {
      path: "centro-de-custo/regra/:id",
      name: "centrodecusto-regra",
      meta: {
        label: "Listar",
        icon: "list",
        show: false,
      },
      component: () =>
        import(
          /* webpackChunkName: "centrodecusto" */ "./views/RegraCentroDeCusto.vue"
        ),
    },
  ],
};

export default centroDeCustoRoutes;
